export default {
    name: 'Name',
    organisation: 'Organisation',
    statisticSurvey: 'Erhebung',
    statisticSurveyPeriod: 'Erhebungszeitraum',
    statisticForm: 'Statistikformular',
    status: 'Status',
    statusKey: 'Status',
}